import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  portfolioQueryKeys,
  portfolioSnowflakeCreateUrl,
} from '@/lib/portfolio/api';
import type { SnowflakeConnectionRequest } from '@/lib/portfolio/snowflake-types';

export function useCreateSnowflakeRequest(portfolioId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (orgId: number) =>
      apiPost<SnowflakeConnectionRequest>(
        portfolioSnowflakeCreateUrl(portfolioId, orgId),
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgSnowflakeStatuses(portfolioId),
      });
    },
  });
}
